import { z } from 'zod';
import type { ContributorGroupToken } from '@sleed/bizcommerce-api';

/**
 * Contributor group (Ομάδα Συντελεστών) edit form. Mirrors the legacy admin grid
 * (Core/client/admin/src/pages/Contributors/ContributorGroups/index.js): nm required ≤100,
 * cd required ≤50, desc optional, iv boolean, si required. `nm`/`desc` are the default-language
 * values saved top-level via the Accept-Language=el pin (GetAllMasterEntityML, parity with Seasons).
 */
export const contributorGroupSchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	cd: z.string().trim().min(1, 'validation.required').max(50, 'validation.tooLong'),
	desc: z.string().nullable(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type ContributorGroupFormValues = z.infer<typeof contributorGroupSchema>;

export const EMPTY_CONTRIBUTOR_GROUP: ContributorGroupFormValues = {
	nm: '',
	cd: '',
	desc: null,
	iv: true,
	si: 0
};

export function tokenToForm(token: ContributorGroupToken): ContributorGroupFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		cd: token.cd ?? '',
		desc: token.desc ?? null,
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: ContributorGroupFormValues, original?: ContributorGroupToken | null): ContributorGroupToken {
	return {
		...(original ?? {}),
		id: form.id,
		nm: form.nm.trim(),
		cd: form.cd.trim(),
		desc: form.desc?.trim() || null,
		iv: form.iv,
		si: form.si
	};
}
